import { PropsWithChildren } from 'react'
import { Button } from '@chakra-ui/react'

type Props = PropsWithChildren & {
  isCategorySelected: boolean
}

const CategoryButton = ({ children, isCategorySelected }: Props): JSX.Element => {
  return (
    <Button
      color="white"
      padding="14px 12px"
      borderRadius="xl"
      transition="background 0.2s ease"
      background={isCategorySelected ? 'green.a150' : 'transparent'}
      cursor="pointer"
      height="auto"
      lineHeight={'moderate'}
      fontSize="smd"
      fontWeight="normal"
      _hover={{
        background: 'green.a150',
      }}
      _focus={{
        outline: 'none',
        boxShadow: 'none',
      }}
    >
      {children}
    </Button>
  )
}

export default CategoryButton
